import React from 'react';
import type { FieldProps } from 'formik';
import 'formik';
type Props = FieldProps;
export const Hidden = ({ field }: Props) => (
  <input
    id={field.name}
    type="hidden"
    {...field} // to not trigger a React error when the field is initialize to undefined
    value={field.value || ''}
  />
);
